<script>
    import { mapActions } from 'vuex';

    export default {
        methods: {
            ...mapActions('logos', ['setCurrentLogo']),
        },
        render() {
            return this.$scopedSlots.default({
                updateLogo: name => this.setCurrentLogo({ name }),
            });
        },
    };
</script>
